$ = require 'jquery'
CalendarView = require 'views/calendar/calendar-view'
CalendarWeekDayView = require 'views/calendar/calendar-week-day-view'
Controller = require 'controller'
Dates = require 'lib/dates'
DragSort = require 'views/lib/drag-sort'
Util = require 'lib/util'
templates = require 'views/internal/templates'
moment = require 'moment'

module.exports = class CalendarWeekView extends CalendarView
  className: Util.extendParentClassName('calendar-week')
  WEEK_WRAPPER_ELEMENT: 'div'
  VIEWSTATE_PREF_STR: 'week'
  HEADER_CLASS_NAME: 'week-view'
  WEEKS_KEPT_IN_DOM: 5

  initialize: ->
    super
    @DAY_VIEW_TYPE = CalendarWeekDayView
    @today = new Date()
    @scrollLock = false

  render: (day = @today) ->
    @$el.html(templates.fill('calendar_week'))
    @currentWeek = Dates.getStartOfWeek(day)
    @appendWeekEl(@currentWeek)

    @prependWeekEl moment(@currentWeek).subtract(1, 'weeks').toDate()
    @appendWeekEl moment(@currentWeek).add(1, 'weeks').toDate()
    @

  addedToDOM: ->
    super
    @weekWidth = $('.calendar-content').outerWidth()
    @resizeWeekCanvas()
    @scrollToDay(@currentWeek)
    @updateToolbar()

  updateRoute: ->
    { year, month, day } = Dates.dateToObj @currentWeek
    month = Util.lpad month, 2, '0'
    day = Util.lpad day, 2, '0'

    Controller.setBoardLocation(
      @model.id,
      'calendar',
      [year, month, day],
      { replace: true }
    )

  setSubscriptions: ->
    $(window).on "resize.#{ @uniqueId() }", => @resizeCheck()
    $('.board-menu').on(
      "transitionend.#{ @uniqueId() } webkitTransitionEnd.#{ @uniqueId() }",
      => @resizeCheck())

  stopSubscriptions: ->
    $(window).off(".#{ @uniqueId() }")
    $('.board-menu').off(".#{ @uniqueId() }")

  resizeCheck: ->
    @weekWidth = $('.calendar-content').outerWidth()
    @resizeWeekCanvas()
    @scrollToDay(@currentWeek)

  resizeWeekCanvas: ->
    weeksRendered = @$('.week').length
    $('.week-horizontal-canvas').width(@weekWidth * weeksRendered)
    $('.week').width(@weekWidth)

  updateToolbar: ->
    weekEnd = moment(Dates.getEndOfWeek(@currentWeek))
    currentWeek = moment(@currentWeek)
    header =
      "#{ currentWeek.format('LL') } - #{ weekEnd.format('LL') }"
    $('.js-calendar-header').text(header)

    $todayButton = $('.today-button')
    isViewingToday = moment(@today).isSame(@currentWeek, 'week')
    $todayButton.toggleClass('on-today', isViewingToday)

  appendWeekEl: (day) ->
    target = @$('.week-horizontal-canvas')
    target.append(@weekRowEl(day))
    @resizeWeekCanvas()

    $weeks = @$('.week')
    if $weeks.length > @WEEKS_KEPT_IN_DOM
      $weeks.first().remove()
      @scrollLeft(-1 * @weekWidth)

    @calculateFirstAndLastWeeksFromDOM()

  prependWeekEl: (day) ->
    target = @$('.week-horizontal-canvas')
    target.prepend(@weekRowEl(day))
    $weeks = @$('.week')
    if $weeks.length > @WEEKS_KEPT_IN_DOM
      $weeks.last().remove()
    @resizeWeekCanvas()
    @scrollLeft(@weekWidth)

    @calculateFirstAndLastWeeksFromDOM()

  navigatePrevious: -> @navigateWeek({ backwards: true })
  navigateNext: -> @navigateWeek({ backwards: false })

  navigateWeek: ({ backwards } = {}) ->
    if !@scrollLock
      weeksToAdd = if backwards then -1 else 1
      $targetWeek = if backwards then @$('.week').first() else @$('.week').last()

      @currentWeek = moment(@currentWeek).add(weeksToAdd, 'weeks')
      weekID = $targetWeek.attr('name')
      weekDate = new Date(parseInt(weekID))

      if moment(@currentWeek).isSame(weekDate, 'day')
        if backwards
          @prependWeekEl moment(@currentWeek).subtract(1, 'weeks').toDate()
        else
          @appendWeekEl moment(@currentWeek).add(1, 'weeks').toDate()

        if @model.editable()
          # Very slow, so defer it until after render finishes
          @defer ->
            DragSort.refreshCalendarCardSortable()

      @scrollToDay(@currentWeek, @SCROLL_ANIMATION_TIME )

  scrollLeft: (pixels, speed) ->
    $scrollArea = $('.calendar-week')
    currentScroll = $scrollArea.prop('scrollLeft')
    @scrollLeftTo(currentScroll + pixels, speed)

  scrollLeftTo: (scrollLeft, speed) ->
    $scrollArea = $('.calendar-week')
    if speed
      @scrollLock = true
      $scrollArea.animate(
        { scrollLeft: scrollLeft },
        { duration: speed, complete: (=> @completeAnimatedScroll()) }
      )
    else
      $scrollArea.scrollLeft(scrollLeft)

  # Scroll to the day if possible, otherwise rerender the week view
  scrollToDay: (day, speed) ->
    if @firstRenderedWeek < day < @lastRenderedSaturday
      startOfWeekInt = Dates.getMidnightInt(Dates.getStartOfWeek(day))
      $targetWeek = @$(".week[name='#{ startOfWeekInt }']")
      offsetLeft = $targetWeek.prop('offsetLeft')
      @scrollLeftTo(offsetLeft, speed)
      @currentWeek = new Date(startOfWeekInt)
      @updateToolbar()
    else
      @render(day)
      @addedToDOM()
      @delegateEvents()
    @updateRoute()

  completeAnimatedScroll: ->
    @scrollLock = false



// WEBPACK FOOTER //
// ./app/scripts/views/calendar/calendar-week-view.coffee